import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page77() {
  useEffect(() => {
    document.title = "Маяк — Страница 76"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page75" />
        <ForwardLink href="/page77" />
      </div>

      <p style={{ textAlign: "right" }}>76.</p>
      <p>СНАРУЖИ. МАЯК. ПОМОСТ – НОЧЬ</p>
      <p>ВЕТЕР И ДОЖДЬ СВИРЕПСТВУЮТ ПО ПЕРЕХОДУ НА ВЕРШИНЕ БАШНИ.</p>
      <p>Они толкают и бьют МОЛОДОГО, пока он осторожно пробирается к...</p>
      <p>ТЕЛУ.</p>
      <p>Лицом вниз. <i>Это СТАРИК?</i></p>
      <p>НЕТ. Но это знакомое – ПАЛЬТО МАКИНО...</p>
      <p>ВЫСОКИЕ КОЖАНЫЕ БОТИНКИ С ТОЛСТЫМИ ШИПОВАННЫМИ ПОДОШВАМИ...</p>
      <p>
        По какой-то причине, менее всего известной МОЛОДОМУ, он тянется<br/>
        к знакомому человеку и переворачивает мокрое тело:
      </p>
      <p><u>ЭТО МОЛОДОЙ!</u> <u>ЕГО ДВОЙНИК.</u> <u>БЛЕДНЫЙ.</u> <u>МЕРТВЫЙ.</u></p>
      <p><i><u>АУДИО:</u> ИДЕТ-ХРОМАЯ. ИДЕТ-ХРОМАЯ. ИДЕТ-ХРОМАЯ.</i></p>
      <p>НЕУКЛЮЖИЕ ШАГИ ЗВУЧАТ ГРОМКО. ЯРОСТНО. ПРЯМО ЗА МОЛОДЫМ!</p>
      <p>
        КТО-ТО ХВАТАЕТ ЕГО ЗА ЗАПЯСТЬЕ СЗАДИ. ЖЕСТКОЙ ХВАТКОЙ.<br/>
        РАЗВОРАЧИВАЕТ МОЛОДОГО... <u>ЭТО</u> <u>СТАРИК</u>. <u>ГОЛЫЙ</u>.
      </p>
      <p>
        МОЛОДОЙ В ЕГО ВЛАСТИ. В ЕГО ВОЛЕ. НО... ГЛАЗА<br/>
        СТАРИКА ЗАКРЫТЫ.
      </p>
      <p>
        МОЛОДОЙ пытается вырваться. Но не может. СТАРИК слишком<br/>
        силен. И что-то начинает происходить. Что-то ужасное...
      </p>
      <p>СТАРИК МЕДЛЕННО ОТКРЫВАЕТ ГЛАЗА.</p>
      <p>
        Выражение лица МОЛОДОГО говорит само за себя: восхищение быстро сменяется<br/>
        замешательством и глубоким, неведомым ужасом, когда ...
      </p>
      <p>СВЕТ ЯРЧЕ ЧЕМ ЧТО-ЛИБО ОЗАРЯЕТ ЛИЦО МОЛОДОГО!</p>
      <p>
        ГЛАЗА СТАРИКА СВЕТЯТ КАК СВЕТ МАЯКА В ЛИЦО<br/>
        МОЛОДОГО.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – РАССВЕТ</p>
      <p>БЛИЗКО: МОЛОДОЙ БЕЖИТ СКВОЗЬ ШТОРМ!</p>
      <br/>
      <p>ВНУТРИ/СНАРУЖИ. ЛОДОЧНЫЙ САРАЙ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>
        МОЛОДОЙ с крайним отчаянием пытается спустить ДОРИ (спасательную лодку)<br/>
        в море. Он надевает ПРОБКОВЫЙ СПАСАТЕЛЬНЫЙ ЖИЛЕТ.
      </p>
      <p>ОГРОМНЫЕ ВОЛНЫ РАЗБИВАЮТСЯ ОБ НЕГО.</p>
      <p style={{ textAlign: "right" }}>76.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page75" />
        <ForwardLink href="/page77" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710772338/the-lighthouse-script/gbo1nljmtlmwafageyg8.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page77;
